module.exports = __webpack_public_path__ + "img/mikk_laanemets.51ee4b38.jpeg";